
import { defineComponent, SetupContext, PropType, ref, computed, ComponentPublicInstance, onMounted } from "vue";
import FridgeDetailsTabsItem from "./FridgeDetailsTabsItem.vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "FridgeDetailsTab",
  components: { FridgeDetailsTabsItem },
  props: {
    /** 表示する文字列 */
    titleList: {
      type: Array as PropType<string[]>,
      required: true
    },
    /** 初期選択位置 */
    initialSelectedIndex: {
      type: Number,
      default: 0
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("FridgeDetailsTab setup start");
    // 表示更新のためのリアクティブ
    const updateDisplayKey = ref(0);
    const updateDisplay = () => {
      if (updateDisplayKey.value == 100) {
        updateDisplayKey.value = 0;
      } else {
        updateDisplayKey.value++;
      }
    };

    // 設定値
    const selectTabIndex = ref(props.initialSelectedIndex);

    // 内部で使用
    interface FridgeDetailsTabInfo {
      index: number;
      title: string;
      selected: boolean;
    }
    const tabList = ref(Array<FridgeDetailsTabInfo>());
    const setTablist = () => {
      const result: Array<FridgeDetailsTabInfo> = []
      for (let index = 0; index < props.titleList.length; index ++) {
        const item: FridgeDetailsTabInfo = { index: index, title: props.titleList[index], selected: (selectTabIndex.value == index) };
        result.push(item);
      }
      tabList.value = result;
    };

    // 表示
    onMounted(() => {
      NativeClient.sendDebugLog("FridgeDetailsTab onMounted()");
      setTablist();
    });

    //
    // ボタンの処理
    //
    const selectItem = (index: number) => {
      NativeClient.sendDebugLog("FridgeDetailsTab selectIndex = " + index);
      if (index == selectTabIndex.value) {
        return;
      }
      selectTabIndex.value = index;
      setTablist();
      context.emit("change-tab", index);
    };

    return {
      tabList,
      selectItem
    };
}
});
